'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002483 from "./presto.-Two-Factor-Auth-View$$anon$83.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002485 from "./presto.-Two-Factor-Auth-View$$anon$85.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002487 from "./presto.-Two-Factor-Auth-View$$anon$87.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002489 from "./presto.-Two-Factor-Auth-View$$anon$89.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$82() {
  this.bI1 = null;
  this.bHT = null;
  this.bHU = false;
  this.bI2 = null;
  this.bI3 = false;
  this.bI6 = null;
  this.bHZ = null;
  this.bI0 = false;
  this.bHV = null;
  this.bHW = false;
  this.bHX = null;
  this.bHY = false;
  this.bI4 = false;
  this.bI5 = false;
  this.bI1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bI6 = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$82 as $c_Lpresto_TwoFactorAuthView$$anon$82 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$82.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$82;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$82() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$82 as $h_Lpresto_TwoFactorAuthView$$anon$82 };
$h_Lpresto_TwoFactorAuthView$$anon$82.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bI1;
});
$p.L = (function() {
  if ((!this.bHU)) {
    this.bHT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bHU = true;
  }
  return this.bHT;
});
$p.O = (function() {
  if ((!this.bI3)) {
    this.bI2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bI3 = true;
  }
  return this.bI2;
});
$p.E = (function() {
  return this.bI6;
});
$p.t = (function() {
  if ((!this.bI0)) {
    this.bHZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bI0 = true;
  }
  return this.bHZ;
});
$p.M = (function() {
  if ((!this.bHW)) {
    this.bHV = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002483.$c_Lpresto_TwoFactorAuthView$$anon$83(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002485.$c_Lpresto_TwoFactorAuthView$$anon$85())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002487.$c_Lpresto_TwoFactorAuthView$$anon$87())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bHW = true;
  }
  return this.bHV;
});
$p.Q = (function() {
  if ((!this.bHY)) {
    this.bHX = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002489.$c_Lpresto_TwoFactorAuthView$$anon$89();
    this.bHY = true;
  }
  return this.bHX;
});
$p.w = (function() {
  if ((!this.bI5)) {
    this.bI4 = false;
    this.bI5 = true;
  }
  return this.bI4;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee983) => ((p) => \u03b4scrutinee983.z5(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$82 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$82, "presto.TwoFactorAuthView$$anon$82", ({
  Tn: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$82 as $d_Lpresto_TwoFactorAuthView$$anon$82 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$82.js.map
